import React from "react";
import { useTranslation } from "react-i18next";
import { LabelColumn, Row, ValueColumn } from "src/components/shared/Sidebar/SidebarTable";
import { formatNumberAsPercentage } from "src/utils";

interface Props {
    lender?: string;
    rate?: number;
    paymentType: string;
}

const BestBankRate = ({ lender, rate, paymentType }: Props) => {
    const { t } = useTranslation();

    if (paymentType === "cash" || lender === undefined) {
        return null;
    }

    return (
        <Row>
            <LabelColumn>{t("ContinueDeal.VehicleInfo.bankLabel")}</LabelColumn>
            <ValueColumn>
                {rate && `${formatNumberAsPercentage(rate)} `}
                {lender}
            </ValueColumn>
        </Row>
    );
};

export default BestBankRate;
